import createIcon from '../../createIcon';

/**
 * @component @name ArrowForward
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNEwxMC41OSA1LjQxTDE2LjE3IDExSDRWMTNIMTYuMTdMMTAuNTkgMTguNTlMMTIgMjBMMjAgMTJMMTIgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowForward = createIcon('ArrowForward', [
  [
    'path',
    { d: 'M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z', key: 'hnldra' },
  ],
]);

export default ArrowForward;
